import { Application, AppStatuses } from '../../gql/graphql';
import { APP_FINISHED_LEASE_STATUSES } from '../../constants/app-status';
import { getApplicationDetails } from './getApplicationDetails';

// approved / docsReady / signed and beyond: post-decision-machine's statuses. Its Entry errors
// on any other, so every IsPostDecisionStatus guard routes through here to keep the set in sync.
// Reads the active product, so an installment loan (OR-3032) hands off the same way as a lease.
export const POST_DECISION_STATUSES: AppStatuses[] = [AppStatuses.Approved, AppStatuses.DocsReady, ...APP_FINISHED_LEASE_STATUSES];

export const isPostDecisionStatus = (application?: Application | null): boolean =>
  POST_DECISION_STATUSES.includes(getApplicationDetails(application)?.status as AppStatuses);
